// Section 17 and 18: Household sharing policy. A member fed in full passes 25% of their surplus
// (config.rationing.householdSharingFraction) to short members of the household.
// Default: config.policies.defaults.householdSharing.
import type { Config } from '../../config';
import { noChangeCost, noProblem } from '../../core/content-helpers';
import { sortedValues } from '../../core/sorted';
import { definePolicy, noModifiers } from '../../core/registry';

export function householdSharing(config: Config) {
  return definePolicy({
    id: 'householdSharing',
    label: 'Household sharing',
    section: 'S18',
    group: 'rations',
    options: [true, false],
    default: config.policies.defaults.householdSharing,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: noChangeCost,
    affects(ctx, on) {
      const shared = sortedValues(ctx.state.households).filter((h) => h.memberIds.length > 1);
      return [
        {
          key: on ? 'policy.householdSharing.on' : 'policy.householdSharing.off',
          params: {
            households: shared.length,
            pct: Math.round(config.rationing.householdSharingFraction * 100),
          },
        },
      ];
    },
    validate: noProblem,
  });
}
